module.exports = __webpack_public_path__ + "static/media/icon_box_3d_selected.3c666e15.svg";